"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _utils = require("../utils");

class Synthetic {
  constructor(provider) {
    this.apiProvider = void 0;
    this.api = void 0;

    this.allPoolIds = () => {
      return this.api.query.baseLiquidityPoolsForSynthetic.nextPoolId().pipe((0, _operators.map)(result => [...new Array(result.toNumber())].map((_, i) => `${i}`)));
    };

    this.redeem = async (account, poolId, fromToken, fromAmount) => {
      const extrinsic = this.api.tx.syntheticProtocol.redeem(poolId, fromToken, fromAmount, '0');
      return this.apiProvider.extrinsicHelper(extrinsic, account, {
        action: 'Swap'
      });
    };

    this.mint = async (account, poolId, toToken, fromAmount) => {
      const extrinsic = this.api.tx.syntheticProtocol.mint(poolId, toToken, fromAmount, '100000000000000000000000');
      return this.apiProvider.extrinsicHelper(extrinsic, account, {
        action: 'Swap'
      });
    };

    this.apiProvider = provider;
    this.api = provider.api;
  }

  poolInfo(poolId) {
    return (0, _rxjs.combineLatest)([this.api.query.baseLiquidityPoolsForSynthetic.pools(poolId), this.api.query.syntheticLiquidityPools.poolCurrencyOptions.entries(poolId), this.api.query.syntheticLiquidityPools.minAdditionalCollateralRatio(), this.api.query.syntheticLiquidityPools.maxSpread.entries()]).pipe((0, _operators.map)(([pool, liquidityPoolOptions, minAdditionalCollateralRatio, allMaxSpread]) => {
      if (pool.isEmpty) return null;
      const {
        owner,
        balance
      } = pool.unwrap();
      const maxSpreadMap = new Map();

      for (const [storageKey, value] of allMaxSpread) {
        if (!value.isNone) {
          maxSpreadMap.set(storageKey.args.toString(), value.unwrap());
        }
      }

      return {
        poolId: poolId,
        owner: owner.toString(),
        balance: balance.toString(),
        options: liquidityPoolOptions.map(([storageKey, options]) => {
          const tokenId = storageKey.args[1].toString();
          let {
            bidSpread,
            askSpread,
            additionalCollateralRatio: poolAdditionalCollateralRatio
          } = options;
          const additionalCollateralRatio = poolAdditionalCollateralRatio.isNone || minAdditionalCollateralRatio.gt(poolAdditionalCollateralRatio.unwrap()) ? minAdditionalCollateralRatio : poolAdditionalCollateralRatio.unwrap();
          const maxSpread = maxSpreadMap.get(tokenId);

          if (maxSpread && !bidSpread.isNone && bidSpread.unwrap().gt(maxSpread)) {
            bidSpread = maxSpread;
          }

          if (maxSpread && !askSpread.isNone && askSpread.unwrap().gt(maxSpread)) {
            bidSpread = maxSpread;
          }

          return {
            tokenId: tokenId,
            askSpread: askSpread.toString(),
            bidSpread: bidSpread.toString(),
            additionalCollateralRatio: (0, _utils.permillToFixedU128)(additionalCollateralRatio).toString()
          };
        })
      };
    }));
  }

  depositLiquidity(account, poolId, amount) {
    const extrinsic = this.api.tx.baseLiquidityPoolsForSynthetic.depositLiquidity(poolId, amount);
    return this.apiProvider.extrinsicHelper(extrinsic, account, {
      action: 'Deposit Liquidity'
    });
  }

  withdrawLiquidity(account, poolId, amount) {
    const extrinsic = this.api.tx.baseLiquidityPoolsForSynthetic.withdrawLiquidity(poolId, amount);
    return this.apiProvider.extrinsicHelper(extrinsic, account, {
      action: 'Withdraw Liquidity'
    });
  }

}

var _default = Synthetic;
exports.default = _default;